<template>
  <div class="textColor">
    <div v-for="n in 6" :track-by="n" :key="n">
      <p class="b">{{questions[n]}}</p>
      <p>{{answers[n]}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faqs-es',
  data () {
    return {
      questions: [
        '¿Los masterings se encargan ustedes?',
        '¿La música debe ser exclusiva para Beathey?',
        '¿Qué hace Beathey? ¿Qué lo diferencia?',
        'Subiendo mi música a BeatHey, ¿Tengo mas oportunidades de ser parte de los eventos?',
        '¿Qué gano pagando una suscripción?',
        '¿Porque me suscribiría a Beathey teniendo otras plataformas?'
      ],
      answers: [
        'No. los tracks deben subirlos masterizados ya que los usuarios que los compran, son artistas que usaran la musica en sus actuaciones.',
        'La música que subes a BeatHey no tiene que ser exclusiva. Puede ser música editada con anterioridad. Tu eres responsable por el material que subes a BeatHey. Te recomendamos leer los TyC de BeatHey antes de subir música.',
        'BeatHey es un Market network para artistas independientes. Puedes subir tu música directamente a BeatHey, sin intermediarios ni agregadoras, y obtendrás el 100% de las ganancias sobre tus ventas conservando el 100% de los derechos de la misma. También participarás del contest donde los cuatros artistas más votados del trimestre ganan un premio en efectivo y son editados en un disco digital. Este disco es gratuito para toda la comunidad.En BeatHey cada reproducción cuenta!! Pagamos por Streaming. Cuanto más te escuchen en BeatHey mas podrás monetizar tu trabajo. BeatHey, adicionalmente, edita su propia revista, produce eventos, edita discos, produce radio shows y fomenta la escena cultural independiente global.',
        'En BeatHey tenemos como misión generar más y mejores oportunidades de monetización y exposición a los artistas independientes. Si eres parte de la comunidad BeatHey puedes ser parte de nuestros eventos, radio shows, Revistas, discos y demás acciones culturales que realizamos.',
        'Pagando una suscripción a BeatHey contribuyes al crecimiento de la escena musical independiente y recibes diferentes beneficios; revistas gratuitas, discos digitales gratuitos y descuentos en shows son algunos de ellos.',
        ' BeatHey es una herramienta MÁS que SUMA y se acopla con las demás plataformas. La audiencia de BeatHey, 50 países, busca música que en otras plataformas es difícil de encontrar si no la buscas directamente. BeatHey brinda una oportunidad no sólo de monetización, sino también de formación y crecimiento conjunto.'
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/help/FaqsEs.vue